import { render, staticRenderFns } from "./ParamTipoCarga.vue?vue&type=template&id=3b5a559a"
import script from "./ParamTipoCarga.vue?vue&type=script&lang=js"
export * from "./ParamTipoCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports